const ITEMS = [
  "WEBSITES",
  "AI VIDEO ADS",
  "AUTOMATIONS",
  "DIGITAL EXPERIENCES",
  "CONVERSION FOCUSED",
];

const COLORS = ["#2563EB", "#FF6B35", "#7C3AED", "#65A30D", "#2563EB"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section className="relative border-y border-slate-200 bg-white py-5 sm:py-6" data-testid="marquee-section" aria-hidden="true">
      <div className="flex overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
        <div className="flex shrink-0 animate-marquee items-center gap-8 pr-8 sm:gap-12 sm:pr-12">
          {row.map((item, i) => (
            <span key={i} className="flex items-center gap-8 sm:gap-12">
              <span className="font-display text-2xl font-extrabold tracking-tight text-[#111827] sm:text-4xl">
                {item}
              </span>
              <span className="text-2xl sm:text-3xl" style={{ color: COLORS[i % COLORS.length] }}>
                ✦
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
